export default "__VITE_ASSET__SE2sQ765__"